export class ProcessoInstancia{
    Id: number;
    ProcessoId: number;
    InstanciaId: number;
    Numero: string;
    NumeracaoUnica: string;
    OrgaoJudiciarioId?: number;
    Padrao: boolean;

    constructor(){
        this.Id = 0;
        this.InstanciaId = 0;
        this.ProcessoId = 0;
        this.OrgaoJudiciarioId = null;
        this.Numero = '';
        this.NumeracaoUnica = '';
        this.Padrao = false;
    }
}
